import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { ResponsiveBar } from '@nivo/bar'

import i18n from 'modules/core/lib/i18n'

import {
  BAR_HEIGHT,
  BAR_RADIUS,
  SMALL_BAR_HEIGHT,
  SMALL_BAR_RADIUS,
  barTheme,
} from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/lib/barsHelper'

// TODO: Move this to a shared component
import InfoDotMemo from '../../../Compensation/Header/Bar/InfoDotMemo'
import { calculateTimeForLegend } from '../../Legend/utils/calculateTimeForLegend'
import { colors, generateData, keys } from './generateData'

interface Props {
  minutes: number
  estimatedMinutes: number
  showMemo?: boolean
}

const Bar = ({ minutes, estimatedMinutes, showMemo = false }: Props) => {
  const { regular, overtime, remaining } = calculateTimeForLegend(minutes, estimatedMinutes)

  const data = generateData(estimatedMinutes, regular, overtime, remaining)
  const allZero = regular === 0 && overtime === 0 && remaining === 0

  const height = `${showMemo ? SMALL_BAR_HEIGHT : BAR_HEIGHT}px`
  const radius = showMemo ? SMALL_BAR_RADIUS : BAR_RADIUS

  return (
    <Box>
      {showMemo && (
        <Box flexDirection="row" gap="s8">
          {regular > 0 && (
            <InfoDotMemo
              color="viridian1000"
              label={
                overtime
                  ? i18n.t('clock_in.worked_vs_planned_header.planned')
                  : i18n.t('clock_in.worked_vs_planned_header.worked')
              }
            />
          )}
          {(remaining > 0 || allZero) && (
            <InfoDotMemo
              color="grey400"
              label={i18n.t('clock_in.worked_vs_planned_header.to_complete')}
            />
          )}
          {overtime > 0 && (
            <InfoDotMemo
              color="tangerine1000"
              label={i18n.t('clock_in.worked_vs_planned_header.overtime')}
            />
          )}
        </Box>
      )}
      <Box style={{ height }}>
        <ResponsiveBar
          data={data}
          keys={keys}
          layout="horizontal"
          colors={colors}
          enableLabel={false}
          isInteractive={false}
          animate={false}
          borderRadius={radius}
          innerPadding={2}
          theme={barTheme}
        />
      </Box>
    </Box>
  )
}

export default Bar
